import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon, MDBFormInline  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import Swal from 'sweetalert2'
import { URL,api } from '../api';
import ban from '../img/math.png'

export default class Modalregisterlestten extends Component {
    constructor(props) {
        super(props);
                this.state = {
                modal: false,

                send_id :'1', //ผู้ลงทะเบียน
                send_type : '', //ประเภท
                name_present : '', //ผู้นำเสนอ
                name_article : '', //ชื่อบทความ
                major_precent : 'คณิตศาสตร์', //สาขาที่นำเสนอ
                send_uploadeword1 : null,
                send_uploadepdf1 : null,
                send_uploadeword12 : null,
                send_uploadepdf12 : null,
                send_date1 : '', //  วันที่ส่ง
                send_status : '', //สถานะ ชำระเงิน
                stapat : '0',   //สถานะส่ง

                iduser:'',
                radio: "",
                pnamelisten:"",
                name_listen:"",
                lnamelisten:"",
                agencylisten:"",
                tellisten:"",
                external_typelisten:"",

                registerlisten_taxnumber:"",
                registerlisten_taxadress:"",
                registerlisten_taxDISTRICT:"",
                registerlisten_taxAMPHUR:"",
                registerlisten_taxPROVINCE:"",
                registerlisten_taxCODE:"",

                registertype:[],
               
                }

                this.handleChange1 = this.handleChange1.bind(this);
                this.handleChange2 = this.handleChange2.bind(this);
             //   this.handleChange3 = this.handleChange3.bind(this);
             //   this.handleChange4 = this.handleChange4.bind(this);
                this.handleSubmit = this.handleSubmit.bind(this);


                this.handleChangetype = this.handleChangetype.bind(this);
                this.toggle = this.toggle.bind(this);
                this.handleChangemajor = this.handleChangemajor.bind(this);
                this.handleChangenamepresent = this.handleChangenamepresent.bind(this);
                this.handleChangesend_name = this.handleChangesend_name.bind(this);
                this.onClickradio = this.onClickradio.bind(this);
                this.handleChangesend_tel = this.handleChangesend_tel.bind(this);
                 this.gettax = this.gettax.bind(this);
                 this.handleChangesend_taxx = this.handleChangesend_taxx.bind(this);
                 this.handleChangesend_adress = this.handleChangesend_adress.bind(this);
                  this.handleChange = this.handleChange.bind(this);
                  this.getregistertype = this.getregistertype.bind(this);
                   this.handleChangetypere = this.handleChangetypere.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
  this.gettax();
  this.getregistertype();

}
 gettax() {
    setTimeout(() => {
      //ภายใน
      api.get('registercon/selecttextforlisten/'+localStorage.getItem('iduser'))
      .then(res => {
        console.log(res);
      //  this.setState({ bankname: res.data, loading: false })
       // this.setState({ Expert: res.data})
        if (res.data.length > 0) {
            this.setState({ registerlisten_taxnumber	: res.data[0].register_taxnumber}) 
            this.setState({ registerlisten_taxadress	: res.data[0].register_taxadress}) 
            this.setState({ registerlisten_taxDISTRICT	: res.data[0].register_taxDISTRICT}) 
            this.setState({ registerlisten_taxAMPHUR	: res.data[0].register_taxAMPHUR}) 
            this.setState({ registerlisten_taxPROVINCE	: res.data[0].register_taxPROVINCE}) 
            this.setState({ registerlisten_taxCODE	: res.data[0].register_taxCODE}) 
        }
      }) 
    }, 0);

 }

onClickradio = (nr) => () => {
  this.setState({
    radio: nr,
  });
};

 componentDidMount() {
       const { iduser } = this.props.iduser
    //   console.log(id_send);
       this.setState({ iduser:this.props.iduser})
    //   setTimeout(() => {
    //     //ภายใน
    //      Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
    //     .then(res => {
    //       console.log(res);
    //     //  this.setState({ bankname: res.data, loading: false })
    //       this.setState({ Expert: res.data})
    //     }) 

    //   }, 0);

  }

  getregistertype() {
    setTimeout(() => {
           
      api.get('registercon/selectregistertype')
       .then(res => {
         console.log(res);
       //  this.setState({ bankname: res.data, loading: false })
         const result = res.data.filter((word) => word.price_typeregister	 > 0);
         this.setState({ registertype: result})
       }) 
     }, 0);

}

handleChange(event) {     this.setState({[event.target.name]: event.target.value});   } 
handleChangetypere(event) {    this.setState({external_typelisten: event.target.value});  }


  //ปากเปล่าโปสเตอร์
  handleChangetype(event) {    this.setState({send_type: event.target.value});  }
  //ปากเปล่าโปสเตอร์สาขา
  handleChangemajor(event) {    this.setState({major_precent: event.target.value});  }
  //ผู้นำเสนอ
  handleChangenamepresent(event) {    this.setState({name_listen: event.target.value});  }
//ผู้นำเสนอ
  handleChangesend_name(event) {    this.setState({agencylisten: event.target.value});  }
  handleChangesend_tel(event) {    this.setState({tellisten: event.target.value});  }

  handleChangesend_taxx(event) {    this.setState({registerlisten_taxnumber: event.target.value});  }
  handleChangesend_adress(event) {    this.setState({registerlisten_taxadress: event.target.value});  }




  handleChange1(event) {    this.setState({send_uploadeword1: event.target.files[0]});  }
  handleChange2(event) {    this.setState({send_uploadepdf1: event.target.files[0]});  }
 // handleChange3(event) {    this.setState({send_uploadeword12: event.target.files[0]});  }
 // handleChange4(event) {    this.setState({send_uploadepdf12: event.target.files[0]});  }



  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

    const date = new Date();
    const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
    const dates = day+"-"+month+"-"+year ;

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("send_id", this.props.iduser);
      datafrm.append("pnamelisten", this.state.pnamelisten);
      datafrm.append("namelisten", this.state.name_listen);
      datafrm.append("lnamelisten", this.state.lnamelisten);
      datafrm.append("agencylisten", this.state.agencylisten);
      datafrm.append("tellisten", this.state.tellisten);
      datafrm.append("registerlisten_taxnumber", this.state.registerlisten_taxnumber);
      datafrm.append("registerlisten_taxadress", this.state.registerlisten_taxadress);
      datafrm.append("registerlisten_taxDISTRICT", this.state.registerlisten_taxDISTRICT);
      datafrm.append("registerlisten_taxAMPHUR", this.state.registerlisten_taxAMPHUR);
      datafrm.append("registerlisten_taxPROVINCE", this.state.registerlisten_taxPROVINCE);
      datafrm.append("registerlisten_taxCODE", this.state.registerlisten_taxCODE);
      datafrm.append("external_typelisten", this.state.external_typelisten);

      datafrm.append("sendlisten_date", dates);
  
    api.post("registercon/Insertlisten",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
    console.warn(res);
     console.log("response: ", res)
     if (res.data.length !== 0) {
      // this.showitem = true;
       console.log(res)
       console.log(res.data.length) 
    }else{
     // window.location.href = '/'
    }


    if (res.data = '200') {
     // message.success("อัพโหลไฟล์สำเร็จ")
    //  this.setState({ id_send: ""})
     // window.location.href = '/adminfaculty'
     Swal.fire({
      title: 'ลงทะเบียนเข้าร่วมฟังสำเร็จ',
      text: "Add success articles",
      icon: 'success',
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'ตกลง'
    }).then((result) => {
      if (result.isConfirmed) {
        // Swal.fire(
        //   'Deleted!',
        //   'Your file has been deleted.',
        //   'success'
        // )
        this.props.list();
        this.toggle()
      }
    })
    
    }else{
      message.error("อัพโหลไฟล์ไม่สำเร็จ!")
    }

  })



}, 2000);

//window.location.href = '/adminfaculty'
//this.props.updateat();
//this.getExpert()

  }

  

    render() {
        
          console.log(this.state.send_type)
          console.log(this.state.major_precent)
          console.log(this.state.name_present)
          console.log(this.state.send_name)
          console.log(this.state.send_uploadeword1)
          console.log(this.state.send_uploadepdf1)
          console.log(this.state.radio)

          const items = this.state.registertype.map((registertype, i) => (
            <option  value={registertype.id_typeregister} >{registertype.name_typeregister}</option>
          ));

        return (

          
          
            <MDBContainer className='text-left'>
           <div className='text-center'><MDBBtn color="deep-purple" onClick={this.toggle}><MDBIcon icon="plus-square" />  ลงทะเบียนเข้าร่วมรับฟัง (สำหรับบุคคลทั่วไป)</MDBBtn></div> 

            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
              <MDBModalHeader toggle={this.toggle}>ลงทะเบียนเข้าร่วมรับฟังการนำเสนอ</MDBModalHeader>
              <MDBModalBody>
              <img src={ban} className="rounded mx-auto " alt="aligment" />
              <div>
                <br/>

           
                        

                            {/* <div className="mb-2">
                            <label><strong>ประเภทการนำเสนอ</strong></label>
                            <select className="browser-default custom-select" onChange={this.handleChangetype}>
                                        <option>------กรุณาเลือกประเภทนำเสนอ------</option>
                                         <option value="1" >นำเสนอแบบปากเปล่า</option>
                                         <option value="2" >นำเสนอแบบโปสเตอร์</option>
                            </select>
                            </div> */}

                        <div className="mb-2">
                            <label><strong>ประเภทผู้ลงทะเบียน</strong></label>
                            <select className="browser-default custom-select" onChange={this.handleChangetypere} required>
                              <option value="" >---เลือกประเภทผู้ลงทะเบียน---</option>
                              {items}
                                    
                            </select>
                            </div>

                            <div className="mb-2">
                                <label>คำนำหน้า</label><label className="red-text">*</label>
                                <input   className="form-control" onChange={this.handleChange} name="pnamelisten"
                                    value={this.state.pnamelisten} placeholder="กรุณาระบุ คำนำหน้า" required  />
                              </div>

                            <div className="mb-2">
                           <label><strong>ชื่อ </strong></label>
                           <input className="form-control" onChange={this.handleChangenamepresent} name="name"
                                    value={this.state.name_listen} placeholder="กรุณาระบุ ชื่อ" required />
                            </div>

                            <div className="mb-2">
                                <label>นามสกุล</label><label className="red-text">*</label>
                                <input   className="form-control" onChange={this.handleChange} name="lnamelisten"
                                    value={this.state.lnamelisten} placeholder="กรุณาระบุ นามสกุล" required  />
                              </div>
                  

                           <div className="mb-2">
                           <label><strong>หน่วยงาน</strong></label>
                           <input className="form-control" onChange={this.handleChangesend_name} name="name"
                                    value={this.state.agencylisten} placeholder="กรุณาระบุหน่วยงาน" required />
                            </div>

                            <div className="mb-2">
                           <label><strong>เบอร์โทร</strong></label>
                           <input className="form-control" onChange={this.handleChangesend_tel} name="name"
                                    value={this.state.tellisten} placeholder="กรุณาระบุเบอร์โทร" required />
                            </div>

                            <div className="mb-2">
                           <label><strong>เลขที่ผู้เสียภาษีของหน่วยงาน</strong></label>
                           <input className="form-control" onChange={this.handleChangesend_taxx} name="name"
                                    value={this.state.registerlisten_taxnumber} placeholder="กรุณาระบุหน่วยงาน" required />
                            </div>

                            <div className="mb-2">
                           <label><strong>ที่อยู่</strong></label>
                           <input className="form-control" onChange={this.handleChangesend_adress} name="name"
                                    value={this.state.registerlisten_taxadress} placeholder="กรุณาระบุเบอร์โทร" required />
                            </div>

                            <div className="mb-2">
                                <label>ตำบล</label><label className="red-text">*</label>
                                <input   className="form-control" onChange={this.handleChange} name="registerlisten_taxDISTRICT"
                                    value={this.state.registerlisten_taxDISTRICT} placeholder="กรุณาระบุ ตำบล" required  />
                              </div>
                              
                              <div className="mb-2">
                                <label>อำเภอ</label><label className="red-text">*</label>
                                <input   className="form-control" onChange={this.handleChange} name="registerlisten_taxAMPHUR"
                                    value={this.state.registerlisten_taxAMPHUR} placeholder="กรุณาระบุ อำเภอ" required  />
                              </div>
                              
                              <div className="mb-2">
                                <label>จังหวัด</label><label className="red-text">*</label>
                                <input   className="form-control" onChange={this.handleChange} name="registerlisten_taxPROVINCE"
                                    value={this.state.registerlisten_taxPROVINCE} placeholder="กรุณาระบุ จังหวัด" required  />
                              </div>

                              <div className="mb-2">
                                <label>รหัสไปรษณีย์</label><label className="red-text">*</label>
                                <input   className="form-control" onChange={this.handleChange} name="registerlisten_taxCODE"
                                    value={this.state.registerlisten_taxCODE} placeholder="กรุณาระบุ รหัสไปรษณีย์" required  />
                              </div>
                             <p className="red-text">ตรวจสอบความถูกต้อง เลขที่ผู้เสียภาษีของหน่วยงาน และที่อยู่ที่จะแสดงในใบเสร็จให้ถูกต้อง</p>
                             <p className="red-text">ใบเสร็จจะออกในรูปแบบอิเล็กทรอนิกส์</p>


                            {/* <div className="mb-2">
                            <label><strong>อัพโหลดไฟล์บทความ <MDBIcon icon="file-word" /> .docx</strong></label>
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange1}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/msword,*,.doc, .docx"
                                    />
                            </div>

                            <div className="mb-2">
                            <label><strong>อัพโหลดไฟล์บทความ <MDBIcon icon="file-pdf" /> .pdf</strong></label>
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange2}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                    />
                            </div> */}


                         {/* <div className="text-center form-group ">
                            <MDBFormInline >
                            <MDBInput
                        gap
                        onClick={this.onClickradio(1)}
                        checked={this.state.radio === 1 ? true : false}
                        label="ท่านยืนยันว่าบทความนี้ไม่ได้มีการตีพิมพ์เผยแพร่ที่ไหนมาก่อน "
                        type="radio"
                        id="radio1"
                        containerClass="mr-5"
                        />
                        </MDBFormInline>
                        </div> */}

                            {/* <div className="mb-2">
                            <label><strong>อัพโหลดไฟล์รับรองบทความ <MDBIcon icon="file-word" /> .docx</strong></label>
                              
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange3}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/msword,*,.doc, .docx"
                                    />
                            </div>

                            <div className="mb-2">
                            <label><strong>อัพโหลดไฟล์รับรองบทความ <MDBIcon icon="file-pdf" /> .pdf</strong></label>
                              
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange4}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                    />
                            </div> */}

                 
              </div>
              
              </MDBModalBody>
              <MDBModalFooter>
                 <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
               
              </MDBModalFooter>
            </MDBModal>
          </MDBContainer>
          
        )
    }
}
